export const fifteenMinutesHaveElapsedSince = (sinceDateStringDateTime) => {
  if (!sinceDateStringDateTime) {
    return true
  }
  return (
    new Date(sinceDateStringDateTime).getTime() + 15 * 60 * 1000 <
    new Date().getTime()
  )
}
